// utils/tsaConditionOptions.ts
export const TSAColumnDataType = {
  STRING: "string",
  NUMBER: "number",
  BOOLEAN: "boolean",
  DATE: "date",
};

export const TSATypesOperators = {
  STARTS_WITH: "startsWith",
  ENDS_WITH: "endsWith",
  IS: "is",
  IS_NOT: "isNot",
  LESS_THAN: "lessThan",
  GREATER_THAN: "greaterThan",
  NOT_EQUAL: "notEqual",
  EQUAL: "equal",
  GREATER_THAN_OR_EQUAL: "greaterThanOrEqual",
  LESS_THAN_OR_EQUAL: "lessThanOrEqual",
  IS_BETWEEN: "isBetween",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
};

// 🔧 Operator options based on data type
export const OPERATOR_OPTIONS = {
  [TSAColumnDataType.STRING]: [
    { label: "Contains", value: TSATypesOperators.CONTAINS },
    { label: "Starts With", value: TSATypesOperators.STARTS_WITH },
    { label: "Ends With", value: TSATypesOperators.ENDS_WITH },
    { label: "Is", value: TSATypesOperators.IS },
    { label: "Is Not", value: TSATypesOperators.IS_NOT },
  ],
  [TSAColumnDataType.NUMBER]: [
    { label: "Less Than", value: TSATypesOperators.LESS_THAN },
    { label: "Greater Than", value: TSATypesOperators.GREATER_THAN },
    { label: "Equal", value: TSATypesOperators.EQUAL },
    { label: "Not Equal", value: TSATypesOperators.NOT_EQUAL },
    {
      label: "Less Than or Equal",
      value: TSATypesOperators.LESS_THAN_OR_EQUAL,
    },
    {
      label: "Greater Than or Equal",
      value: TSATypesOperators.GREATER_THAN_OR_EQUAL,
    },
    { label: "Is Between", value: TSATypesOperators.IS_BETWEEN },
  ],
  [TSAColumnDataType.BOOLEAN]: [
    { label: "Is", value: TSATypesOperators.IS },
    { label: "Is Not", value: TSATypesOperators.IS_NOT },
  ],
  [TSAColumnDataType.DATE]: [
    { label: "Is", value: TSATypesOperators.IS },
    { label: "Is Not", value: TSATypesOperators.IS_NOT },
    { label: "Is Between", value: TSATypesOperators.IS_BETWEEN },
  ],
};

// Helper function to decide value input type
export function getValueInputType(dataType, operator) {
  switch (dataType) {
    case TSAColumnDataType.STRING:
      return "text";
    case TSAColumnDataType.NUMBER:
      return operator == TSATypesOperators.IS_BETWEEN
        ? "number-range"
        : "number";
    case TSAColumnDataType.BOOLEAN:
      return "boolean";
    case TSAColumnDataType.DATE:
      return operator == TSATypesOperators.IS_BETWEEN ? "date-range" : "date";
    default:
      return "text";
  }
}
